/* eslint eqeqeq: "off" */
import * as React from 'react';
import { connect } from 'react-redux';
import { handleNextStep, handleStepBack, setHasBeenRepaired, setRepairStepValid, submitGlassClaim } from '../../../actions/claimSubmitActions';
import { navigateTo } from '../../../actions/navigationActions';
import { CLAIM_INFO_COMPLETE_APPROVED, CLAIM_INFO_COMPLETE_AUTO_AUTHORIZED, CLAIM_INFO_COMPLETE_EXCESS, CLAIM_INFO_COMPLETE_EXCESS_PAYABLE, CLAIM_INFO_COMPLETE_EXCESS_SUBMITTED, CLAIM_INFO_COMPLETE_NOT_AUTO_AUTHORIZED, CLAIM_INFO_COMPLETE_RECEIVED, CLAIM_INFO_COMPLETE_SUBMITTED, CLAIM_INFO_COMPLETE_SUBMITTED2 } from '../../../constants/copy';
import { CLAIM_HISTORY_V2, DASHBOARD } from '../../../routes/routes';
import './Cellphone.css';

var lat = 0
var lng = 0

class CellphoneClaimsComplete extends React.Component<any, any>  {
    constructor(props) {
        super(props)
        this.state = {
        };
        this.handleStepBack = this.handleStepBack.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleViewClaim = this.handleViewClaim.bind(this);
        this.handleViewDashboard = this.handleViewDashboard.bind(this);
    }

    async handleViewClaim() {
        this.props.redirectTo(CLAIM_HISTORY_V2);
    }

    async handleViewDashboard() {
        this.props.redirectTo(DASHBOARD);
    }

    async handleStepBack() {
        this.props.dispatchAction(handleStepBack());
    }

    async handleSubmit() {
        await this.props.dispatchAction(handleNextStep());
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    public render() {
        return (
            <div className="col ssp-container-fnol-repairs ssp-container-fnol-step-header-padding">
                <div className="row noma">
                    <div className="col-12 nopa ssp-header-fnol-ssp-header-fnol-what-happened">
                        <div className="row noma">
                            <div className="fnol-step-header-icon-area">
                                <img src='/my-policy/Images/icon-checkmark-nugreen-32px-32px.svg' alt="Claims Complete" title="Claims Complete" />
                            </div>
                            <div className="col fnol-step-header-title-area claim-info-header">
                                <h3 className="text-green">{this.props.claimSubmit.claimStatus === "" || this.props.claimSubmit.claimStatus === "" ? CLAIM_INFO_COMPLETE_RECEIVED : CLAIM_INFO_COMPLETE_APPROVED}</h3>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row noma  mb-30px">
                    <div className="col-12 fnol-steps-info-section-holder glass-claim-info-holder">
                        <hr className="hr-minus21px" />
                        <div className="">
                            {this.props.claimSubmit.hasBeenRepaired && this.props.claimSubmit.claimStatus !== "" && 
                                <div className="mb-10px">
                                    <p className="line-height-normal">{CLAIM_INFO_COMPLETE_SUBMITTED}</p>
                                    <p className="line-height-normal">{CLAIM_INFO_COMPLETE_SUBMITTED2}</p>
                                </div>
                            }
                            {!this.props.claimSubmit.hasBeenRepaired && this.props.claimSubmit.claimStatus === 4 && <p className="mb-10px line-height-normal">{CLAIM_INFO_COMPLETE_AUTO_AUTHORIZED}</p>}
                            {!this.props.claimSubmit.hasBeenRepaired && this.props.claimSubmit.claimStatus === 2 && <p className="mb-10px line-height-normal">{CLAIM_INFO_COMPLETE_NOT_AUTO_AUTHORIZED}</p>}

                            <p className="mb-12px glass-claims-margin-bottom line-height-normal">If you have any questions you can call us on {this.props.profile.countryId === 244 && <b>0860 50 50 50</b>}{this.props.profile.countryId === 157 && <b>083 600 7000</b>}</p>
                            <p className="mb-0px line-height-normal"><b>Business hours:</b> Mondays to Fridays, 08:00 - 17:00</p>
                            {this.props.claimSubmit.incidentType.description === "Other" &&
                                <div className="nopa fnol-steps-buttonholder mt-40px">
                                    <button className="btn btn-outline-red button-width" onClick={this.handleViewDashboard} id="btnViewDashboard">Back to dashboard</button>
                                </div>
                            }
                        </div>
                        {this.props.claimSubmit.incidentType.description !== "Other" &&
                            <>
                                <hr className="mb-20px mt-19px glassclaims-hr-2px glass-mobile-hr" />
                                <div className="row noma mb-10px">
                                    <div className="col nopa">
                                        <p className="line-height-normal mb-0px"><b>Claim no.</b></p>
                                    </div>
                                    <div className="">
                                        <p className="line-height-normal mb-0px font-weight-500">{this.props.claimSubmit.claimNumber}</p>
                                    </div>
                                </div>
                                <div className="row noma">
                                    <div className="col nopa">
                                        <p className="line-height-normal mb-0px"><b>Excess</b></p>
                                    </div>
                                    <div className="">
                                        <p className="line-height-normal mb-0px font-weight-500">{this.props.profile.currencySymbol + this.props.claimSubmit.claimExcess}</p>
                                    </div>
                                    <div className="col-12 nopa mt-8px glass-claim-excess">
                                    <p className="font-size-12px font-weight-normal mb-0px">{!this.props.claimSubmit.hasBeenRepaired ? CLAIM_INFO_COMPLETE_EXCESS : CLAIM_INFO_COMPLETE_EXCESS_PAYABLE }</p>
                                    
                                    </div>
                                </div>
                                <hr className="mb-20px mt-15px glassclaims-hr-2px glass-mobile-hr" />

                                <p className="text-16 line-height-normal mb-0"><b>Thanks for telling us about your claim</b></p>
                                <p className="font-size-12px font-weight-normal mb-0 mt-8px">Keep an eye on your claim progress by tapping here:</p>
                                <div className="nopa fnol-steps-buttonholder mt-40px">
                                    <button className="btn btn-outline-red button-width" onClick={this.handleViewClaim} id="btnViewClaim">View claim progress</button>
                                </div>
                            </>
                        }
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        props: state.loadingScreen,
        profile: state.profile,
        claimSubmit: state.claimSubmit,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        redirectTo: (destination) => dispatch(navigateTo(destination)),
        dispatchAction: (e) => dispatch(e),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CellphoneClaimsComplete)
